import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export interface TreatmentListItem {
  id: string
  treatment_number: number
  patient_id: string
  veterinarian_id: string | null
  treatment_type: string
  diagnosis: string
  status: string
  treatment_date: string
  created_at: string
  patient_name: string
  patient_species: string
  veterinarian_name: string | null
}

interface TreatmentListState {
  treatments: TreatmentListItem[]
  loading: boolean
  error: string | null
}

const initialState: TreatmentListState = {
  treatments: [],
  loading: false,
  error: null,
}

export const fetchTreatmentList = createAsyncThunk('treatmentList/fetchAll', async () => {
  const res = await fetch('/.netlify/functions/treatments')
  if (!res.ok) throw new Error('Failed to fetch treatments')
  return res.json() as Promise<TreatmentListItem[]>
})

const treatmentListSlice = createSlice({
  name: 'treatmentList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTreatmentList.pending, (state) => {
        if (state.treatments.length === 0) state.loading = true
      })
      .addCase(fetchTreatmentList.fulfilled, (state, action) => {
        state.treatments = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(fetchTreatmentList.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to load'
      })
  },
})

export default treatmentListSlice.reducer
